import 'firebase/firestore';
import 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Import the needed functions from the SDKs.
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
import { bucketRef, firebaseConfig } from './credentials';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize database
const db = getFirestore();

// Initialize storage
const storage = getStorage(app, bucketRef);

// Export app and database
export { app, db, storage };
